/**
 * Promote the existing marine answer observed on 2026-09-13, never a copy.
 * Unknown headings, merchant structures, or missing chapter boundaries keep the
 * original server-rendered article intact. No-JS visitors get that same fallback.
 */
function promoteMarineAnswer(source, headings) {
  const article = source.closest('[data-precision-answer-first]');
  const opening = article?.querySelector('.precision-article__opening');
  if (!opening || article.querySelector('[data-precision-promoted-answer]')) return;

  const matches = headings.filter((heading) => heading.textContent.trim() === 'Det korta svaret');
  if (matches.length !== 1) return;
  const heading = matches[0];
  const parent = heading.parentElement;
  if (parent !== source && !(parent?.tagName === 'DIV' && parent.parentElement === source)) return;

  const intro = heading.nextElementSibling;
  const list = intro?.nextElementSibling;
  if (
    intro?.tagName !== 'P' ||
    intro.textContent.trim() !== 'Du skyddar båtmotorn bäst med en rutin i fem delar:' ||
    list?.tagName !== 'OL' ||
    list.children.length !== 5 ||
    [...list.children].some((item) => item.tagName !== 'LI') ||
    list.nextElementSibling?.tagName !== 'P'
  ) return;

  // Capture the whole bounded section, including whitespace and the caveat/link,
  // before moving any node. A missing next H2 must leave everything in place.
  const nodes = [];
  let nextChapter = null;
  for (let node = heading; node; node = node.nextSibling) {
    if (node !== heading && node.nodeType === 1 && node.tagName === 'H2') {
      nextChapter = node;
      break;
    }
    nodes.push(node);
  }
  if (!nextChapter) return;

  const answer = document.createElement('section');
  answer.className = 'precision-article__answer precision-content-richtext rte';
  answer.setAttribute('data-precision-promoted-answer', '');
  answer.setAttribute('aria-labelledby', heading.id);
  opening.before(answer);
  answer.append(...nodes);
}

const source = document.querySelector('[data-precision-toc-source]');
const target = document.querySelector('[data-precision-toc]');

if (source && target) {
  const headings = [...source.querySelectorAll('h2')];
  if (headings.length > 1) {
    const list = document.createElement('ol');
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `avsnitt-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
    });
    target.append(list);
    const disclosure = target.closest('[data-precision-toc-disclosure]');
    if (disclosure) {
      disclosure.hidden = false;
      const desktopContents = window.matchMedia('(min-width: 990px)');
      const compactContents = disclosure.hasAttribute('data-precision-toc-compact');
      disclosure.open = !compactContents && desktopContents.matches;
      if (!compactContents) {
        desktopContents.addEventListener('change', (event) => { disclosure.open = event.matches; });
      }
      list.addEventListener('click', (event) => {
        if (event.target.closest('a') && (compactContents || window.matchMedia('(max-width: 989px)').matches)) disclosure.open = false;
      });
    }
  } else {
    (target.closest('[data-precision-toc-disclosure]') || target).hidden = true;
  }
  // Build the contents first so moved headings retain their existing links/IDs.
  promoteMarineAnswer(source, headings);
}

(() => {
  const editorial = document.querySelector('.precision-editorial--instructions, .precision-editorial--business, .precision-editorial--company');
  if (!editorial) return;

  function revealEditorialTarget(hash, moveFocus = false) {
    if (!hash || hash === '#') return;
    let id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch {
      return;
    }
    const destination = document.getElementById(id);
    if (!destination || !editorial.contains(destination)) return;

    for (let panel = destination.closest('details'); panel; panel = panel.parentElement?.closest('details')) {
      panel.open = true;
    }
    requestAnimationFrame(() => {
      destination.scrollIntoView({ block: 'start', behavior: 'instant' });
      if (!moveFocus) return;
      const focusTarget = destination.matches('details') ? destination.querySelector('summary') : destination;
      if (!focusTarget) return;
      const temporaryTabIndex = !focusTarget.hasAttribute('tabindex') && !focusTarget.matches('a[href], button, input, select, textarea, summary');
      if (temporaryTabIndex) focusTarget.setAttribute('tabindex', '-1');
      focusTarget.focus({ preventScroll: true });
      if (temporaryTabIndex) focusTarget.addEventListener('blur', () => focusTarget.removeAttribute('tabindex'), { once: true });
    });
  }

  revealEditorialTarget(window.location.hash);
  if (document.readyState !== 'complete') {
    window.addEventListener('load', () => revealEditorialTarget(window.location.hash), { once: true });
  }
  window.addEventListener('hashchange', () => revealEditorialTarget(window.location.hash, true));
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname || destination.search !== window.location.search) return;
    if (destination.hash === window.location.hash) revealEditorialTarget(destination.hash, true);
  });
})();
